module.exports = __webpack_public_path__ + "media/images/top/place/place4-8284703ccb5135ce73662c5b8ac39d9f.png";